export default "__VITE_ASSET__oGRiXLwA__"